unit OperationType;

interface

type
  TOperationType = class
  private
    fOperationKey: String;
  public
    property OperationKey: String read fOperationKey;
  end;

implementation

end.
